"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIframeModalHost = void 0;

var _enviro = _interopRequireDefault(require("enviro"));

function getIsLocal() {
  try {
    return !!localStorage.getItem('UPGRADE_IFRAME_ENV');
  } catch (e) {
    return false;
  }
}

var getIframeModalHost = function getIframeModalHost() {
  var host = _enviro.default.isQa() ? 'hubspotqa.com' : 'hubspot.com';
  return getIsLocal() ? "local." + host : "app." + host;
};

exports.getIframeModalHost = getIframeModalHost;